import React, { createContext, useContext, useState, useEffect } from 'react';
import { createTheme } from '@mui/material/styles';

const FontSizeContext = createContext();

export const FontSizeProvider = ({ children }) => {
  const [fontSize, setFontSize] = useState(16); // base font size in px

  useEffect(() => {
    const stored = localStorage.getItem('fontSize');
    if (stored) setFontSize(parseInt(stored, 10));
  }, []);

  useEffect(() => {
    localStorage.setItem('fontSize', fontSize.toString());
  }, [fontSize]);

  const increaseFont = () => setFontSize((prev) => Math.min(prev + 2, 32));
  const decreaseFont = () => setFontSize((prev) => Math.max(prev - 2, 10));

  return (
    <FontSizeContext.Provider
      value={{ fontSize, setFontSize, increaseFont, decreaseFont }}
    >
      {children}
    </FontSizeContext.Provider>
  );
};

export const useFontSize = () => useContext(FontSizeContext);

// Theme override hook (apply fontSize scale to all variants)
export const useFontSizeTheme = () => {
  const { fontSize } = useFontSize();

  // Skala relatif berdasarkan base fontSize (16px default)
  const scale = fontSize / 16;

  return createTheme({
    typography: {
      fontSize, // global base size (affects rem calculation)
      h1: { fontSize: `${scale * 6}rem` },
      h2: { fontSize: `${scale * 3.75}rem` },
      h3: { fontSize: `${scale * 3}rem` },
      h4: { fontSize: `${scale * 2.125}rem` },
      h5: { fontSize: `${scale * 1.5}rem` },
      h6: { fontSize: `${scale * 1.25}rem` },
      subtitle1: { fontSize: `${scale * 1}rem` },
      subtitle2: { fontSize: `${scale * 0.875}rem` },
      body1: { fontSize: `${scale * 1}rem` },
      body2: { fontSize: `${scale * 0.875}rem` },
      caption: { fontSize: `${scale * 0.75}rem` },
      overline: { fontSize: `${scale * 0.75}rem` },
      button: { fontSize: `${scale * 0.875}rem`, textTransform: 'none' },
    },
    components: {
      MuiTypography: {
        styleOverrides: {
          root: {
            lineHeight: 1.6,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: `${fontSize}px`,
            textTransform: 'none',
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontSize: `${fontSize}px`,
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            fontSize: `${fontSize}px`,
          },
        },
      },
    },
  });
};
